module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/label_original.e0785.png";